var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "80vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_report,
        callback: function($$v) {
          _vm.show_report = $$v
        },
        expression: "show_report"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_report = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              _c(
                "q-tabs",
                {
                  staticClass: "shadow-1",
                  attrs: { color: "secondary" },
                  on: { select: _vm.loadContent },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "downloads",
                      icon: "fas fa-download",
                      label: _vm.$t("downloads")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    {
                      staticClass: "q-px-lg q-pb-xl",
                      attrs: { name: "downloads" }
                    },
                    [
                      _c("q-table", {
                        ref: "table",
                        staticClass: "q-mt-lg",
                        attrs: {
                          data: _vm.downloads,
                          columns: _vm.columns_downloads,
                          "row-key": "id",
                          pagination: _vm.server_pagination,
                          loading: _vm.loading,
                          "no-data-label": _vm.$t("no_data_avaliable"),
                          "no-results-label": _vm.$t("no_results_found"),
                          "loading-label": _vm.$t("loading_data"),
                          "rows-per-page-label": _vm.$t("items_per_page"),
                          "rows-per-page-options": [5, 10, 50, 100],
                          "binary-state-sort": "",
                          filter: _vm.filter_downloads
                        },
                        on: {
                          "update:pagination": function($event) {
                            _vm.server_pagination = $event
                          },
                          request: _vm.requestDownloads
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "top",
                            fn: function(props) {
                              return [
                                _c("q-search", {
                                  attrs: {
                                    icon: "fas fa-search",
                                    placeholder: _vm.$t("search"),
                                    debounce: 500
                                  },
                                  model: {
                                    value: _vm.filter_downloads,
                                    callback: function($$v) {
                                      _vm.filter_downloads = $$v
                                    },
                                    expression: "filter_downloads"
                                  }
                                }),
                                _c("div", { staticClass: "col" }),
                                _c("q-btn", {
                                  attrs: {
                                    color: "secondary",
                                    icon: "fas fa-download",
                                    label: _vm.$t("downloads_report")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadCertificate()
                                    }
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "header",
                            fn: function(props) {
                              return _c(
                                "q-tr",
                                { attrs: { props: props } },
                                _vm._l(props.cols, function(col) {
                                  return _c(
                                    "q-th",
                                    { key: col.name, attrs: { props: props } },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.$t(col.label)) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            }
                          },
                          {
                            key: "body",
                            fn: function(props) {
                              return [
                                _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  [
                                    _c(
                                      "q-td",
                                      {
                                        key: "user_full_name",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(props.row.user_full_name) +
                                            "\n                                "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "user_email",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(props.row.user_email) +
                                            "\n                                "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "download_date",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.fDate(props.row.download_date)
                                            ) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }